var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "purchase-order-detail" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "purchase-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$router.back()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("purchase::purchase-list::order")))]
                ),
                _vm._v(
                  " / " +
                    _vm._s(_vm.$t("purchase::purchase-list::detail")) +
                    " "
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "purchase-status",
                  style: {
                    color: _vm.statusToColor[_vm.purchaseDetail.purchaseStatus],
                    borderColor:
                      _vm.statusToColor[_vm.purchaseDetail.purchaseStatus],
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.purchaseDetail.purchaseStatusName) + " "
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c(
                  "span",
                  {
                    staticClass: "d-label",
                    staticStyle: { "font-weight": "bold" },
                  },
                  [_vm._v(_vm._s(_vm.$t("purchase::purchase-list::order_num")))]
                ),
                _c(
                  "span",
                  {
                    staticClass: "d-value",
                    staticStyle: { "font-weight": "bold" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$dataCheck(_vm.purchaseDetail.purchaseNo))
                    ),
                  ]
                ),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(_vm._s(_vm.$t("purchase::purchase-list::creator"))),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.createName))),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(_vm._s(_vm.$t("purchase::purchase-list::re_auditor"))),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(
                    _vm._s(_vm.$dataCheck(_vm.purchaseDetail.reviewerName))
                  ),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(_vm._s(_vm.$t("purchase::purchase-list::supplier"))),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.supplier))),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("purchase::purchase-list::create_time"))
                  ),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.createTime))),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("purchase::purchase-list::re_audit_time"))
                  ),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.reviewTime))),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("purchase::purchase-list::plan_arrival_date"))
                  ),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(
                    _vm._s(_vm.$dataCheck(_vm.purchaseDetail.arrivalTime))
                  ),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 16 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(_vm._s(_vm.$t("purchase::purchase-list::auditor"))),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(
                    _vm._s(_vm.$dataCheck(_vm.purchaseDetail.auditorName))
                  ),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 8 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("purchase::purchase-list::purchse_total_amount")
                    )
                  ),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.totalPrice))),
                ]),
              ]),
              _c("el-col", { staticClass: "row-item", attrs: { span: 16 } }, [
                _c("span", { staticClass: "d-label" }, [
                  _vm._v(_vm._s(_vm.$t("purchase::purchase-list::audit_time"))),
                ]),
                _c("span", { staticClass: "d-value" }, [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.purchaseDetail.auditTime))),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt10" },
        [
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              columns: _vm.detailColumns,
              data: _vm.purchaseDetail.detail,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "sku-title" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: row.img },
                        }),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _c(
                            "p",
                            {
                              staticClass: "one-line",
                              staticStyle: { width: "250px" },
                            },
                            [_vm._v(_vm._s(row.spuName))]
                          ),
                          _c("p", [_vm._v(_vm._s(row.optionValueNames))]),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "singlePriceHeader",
                fn: function () {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("purchase::purchase-list::single_price")
                        ) +
                        " "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top-start" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::price_equal")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("i", { staticClass: "el-icon-question" }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "quantity",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("purchase::purchase-list::purchase_amount")
                        ) +
                          "：" +
                          _vm._s(row.skuBuyQuantity)
                      ),
                    ]),
                    _c("p", { staticStyle: { color: "#F59A23" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("purchase::purchase-list::arrival_amount")
                        ) +
                          "：" +
                          _vm._s(row.skuArrivalQuantity)
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "progress",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-progress", {
                      attrs: {
                        percentage: _vm.progress(row),
                        color: "#70b603",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }